<template>
  <div class="bg-white flex items-center md:flex-row p-3 mb-5 rounded gap-20 md:gap-5">
    <router-link
      :to="{ name: 'myPublications' }"
      class="nav-link relative h-max text-base font-medium cursor-pointer"
    >
      {{ $t('nav.verifiedPublications') }}
      <span
        class="absolute -top-1 -right-5 text-center text-sm rounded-full bg-green-600 text-white font-normal aspect-square w-5 h-5"
        v-if="getLastSeenMyAcceptedPublicationsCount > 0"
        >{{ getLastSeenMyAcceptedPublicationsCount }}</span
      >
    </router-link>
    <router-link
      :to="{ name: 'publicationRequests' }"
      class="nav-link relative h-max text-base font-medium cursor-pointer text-main-color md:mb-0 md:mr-3"
    >
      {{ $t('nav.unverifiedPublications') }}
      <span
        class="absolute -top-1 -right-5 text-center text-sm rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5"
        v-if="getLastSeenRejectedPublicationsCount > 0"
        >{{ getLastSeenRejectedPublicationsCount }}</span
      >
    </router-link>
    <router-link
      :to="{ name: 'selectBusinessAccount' }"
      class="ml-auto font-semibold text-white py-2.5 px-4 rounded cursor-pointer bg-main-color hover:bg-accent-color md:mb-0 md:mr-3"
    >
      {{ $t('nav.addPublication') }}
    </router-link>
  </div>
</template>
<script>
import { mapState } from 'pinia';
import { useAppStore } from '@/store';
export default {
  name: 'MyPublicationNav.vue',
  computed: {
    ...mapState(useAppStore, [
      'getLastSeenMyAcceptedPublicationsCount',
      'getLastSeenRejectedPublicationsCount',
    ]),
  },
};
</script>
<style scoped>
.router-link-exact-active {
  border-bottom: 1px solid #409dba;
  color: #000000;
}
</style>
